import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import { Scrollable } from '../Scrollable/index.tsx';
import { CenteredLoadingIndicator } from '../Spinner';

const noop = () => null;

const InfiniteScroll = ({
  items,
  onScroll,
  renderInfiniteScrollContent,
  onRequestMore,
  className,
}) => (
  <Scrollable
    onScroll={onScroll}
    className={className}
    onScrollToBottom={() => {
      onRequestMore(items.length);
    }}
    renderScrollableContent={() => (
      <div>
        <div>{renderInfiniteScrollContent(items)}</div>
        <div
          className={css`
            margin-top: 10px;
`}
        >
          <CenteredLoadingIndicator />
        </div>
      </div>
    )}
  />
);

InfiniteScroll.defaultProps = {
  items: [],
  onScroll: noop,
  onRequestMore: noop,
  className: '',
};

InfiniteScroll.propTypes = {
  items: PropTypes.array,
  onScroll: PropTypes.func,
  renderInfiniteScrollContent: PropTypes.func.isRequired,
  onRequestMore: PropTypes.func,
  className: PropTypes.string,
};

export default InfiniteScroll;
